<template>
  <div class="app-main__inner col-sm-12 col-12 m-auto">
    <TituloComponente icono-titulo="fas fa-folder-plus" texto-titulo="Nueva persona"/>
    <div class="tab-content">
      <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
        <div class="row">
          <div class="col-12">
            <form @submit.prevent="guardarPersona()" class="col-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="border-bottom"><i class="fas fa-user btn-icon-wrapper btn-icon-sm mb-2"></i> Datos
                    Personales</h5>
                  <div class="row pt-3">
                    <float-label label="Nombre/s:" clase="col-sm-6 col-12">
                      <input
                        id="nombre"
                        v-model="persona.nombre"
                        placeholder="Ingresar nombre..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.nombre.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.nombre.required"
                        >
                          Debe ingresar el nombre
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Apellido:" clase="col-sm-6 col-12">
                      <input
                        id="apellido"
                        v-model="persona.apellido"
                        placeholder="Ingresar apellido..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.apellido.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.apellido.required"
                        >
                          Debe ingresar el apellido
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Tipo Documento" clase="col-sm-3 col-12">
                      <input id="nombre" v-model="persona.tipo_documento" placeholder="Ingresar Tipo Documento..."
                             type="text" class="form-control"
                             :class="enviado && !$v.persona.tipo_documento.required ? 'is-invalid' : ''"/>
                      <template v-slot:validation>
                        <div class="invalid-feedback" v-if="enviado && !$v.persona.tipo_documento.required">
                          Debe ingresar el Tipo de Documento
                        </div>
                      </template>
                    </float-label>
                    <float-label label="D.N.I.:" clase="col-sm-3 col-12">
                      <input
                        id="dni"
                        v-model="persona.dni"
                        placeholder="Ingresar D.N.I..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.dni.required ? 'is-invalid' : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.dni.required"
                        >
                          Debe ingresar un CUIT
                        </div>
                        <div
                          class="invalid-feedback"
                          v-if="persona.dni && !$v.persona.dni.numeric"
                        >
                          Sólo se aceptan números
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Cuil:" clase="col-sm-3 col-12">
                      <input
                        id="cuil"
                        v-model="persona.cuil"
                        placeholder="Ingresar CUIL..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.cuil.required ? 'is-invalid' : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.cuil.required"
                        >
                          Debe ingresar un CUIT
                        </div>
                        <div
                          class="invalid-feedback"
                          v-if="persona.cuil && !$v.persona.cuil.numeric"
                        >
                          Sólo se aceptan números
                        </div>
                      </template>
                    </float-label>
                    <float-label label="N° afiliado:" clase="col-sm-3 col-12">
                      <input
                        id="numero_afiliado"
                        v-model="persona.numero_afiliado"
                        placeholder="Ingresar N° afiliado..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.numero_afiliado.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.numero_afiliado.required"
                        >
                          Debe ingresar un N° de afiliado
                        </div>
                        <div
                          class="invalid-feedback"
                          v-if="
                            persona.numero_afiliado &&
                              !$v.persona.numero_afiliado.numeric
                          "
                        >
                          Sólo se aceptan números
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Fecha nacimiento:" clase="col-sm-4 col-12">
                      <input
                        id="fecha_nacimiento"
                        v-model="persona.fecha_nacimiento"
                        type="date"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.fecha_nacimiento.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.fecha_nacimiento.required"
                        >
                          Debe ingresar la fecha de nacimiento
                        </div>
                      </template>
                    </float-label>
                  </div>
                </div>
              </div>
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="border-bottom"><i class="fas fa-map-marker-alt btn-icon-wrapper btn-icon-sm mb-2"></i>
                    Datos de Ubicación</h5>
                  <div class="row pt-3">
                    <float-label label="Nacionalidad:" clase="col-sm-4 col-12">
                      <input
                        id="nacionalidad"
                        v-model="persona.nacionalidad"
                        placeholder="Ingresar una Nacionalidad..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.nacionalidad.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.nacionalidad.required"
                        >
                          Debe ingresar un Nacionalidad
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Provincia:" clase="col-sm-4 col-12">
                      <select
                        name="provincia"
                        id="provincia"
                        class="form-control"
                        v-model="provinciaSelected"
                        @change="obtenerMunicipios"
                        :class="
                          enviado && !$v.persona.provincia.required
                            ? 'is-invalid'
                            : ''
                        "
                      >
                        <option value="null">Seleccione una Provincia</option>
                        <option
                          :value="provincia"
                          v-for="provincia in provincias"
                          :key="provincia.nombre"
                        >{{ provincia.nombre }}
                        </option
                        >
                      </select>
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.provincia.required"
                        >
                          Debe ingresar una Provincia
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Localidad:" clase="col-sm-4 col-12">
                      <select
                        name="localidad"
                        id="localidad"
                        class="form-control"
                        v-model="persona.localidad"
                        :class="
                          enviado && !$v.persona.localidad.required
                            ? 'is-invalid'
                            : ''
                        "
                      >
                        <option value="null">Seleccione una Localidad</option>
                        <option
                          :value="municipio.nombre"
                          v-for="municipio in municipios"
                          :key="municipio.nombre"
                        >{{ municipio.nombre }}
                        </option
                        >
                      </select>
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.localidad.required"
                        >
                          Debe ingresar una Localidad
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Domicilio:" clase="col-sm-4 col-12">
                      <input
                        id="domicilio"
                        v-model="persona.domicilio"
                        placeholder="Ingresar una Domicilio..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.persona.domicilio.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.persona.domicilio.required"
                        >
                          Debe ingresar un Domicilio
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Depto:" clase="col-sm-4 col-12">
                      <input
                        id="depto"
                        v-model="persona.depto"
                        placeholder="Ingresar una Depto..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <float-label label="Piso:" clase="col-sm-4 col-12">
                      <input
                        id="piso"
                        v-model="persona.piso"
                        placeholder="Ingresar una Piso..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <float-label label="Codigo postal:" clase="col-sm-4 col-12">
                      <input id="codigoPostal" v-model="persona.codigo_postal"
                             placeholder="Ingresar una codigo postal..." type="text" inputmode="numeric"
                             class="form-control"
                             :class="enviado && !$v.persona.codigo_postal.required ? 'is-invalid' : '' "/>
                      <template v-slot:validation>
                        <div class="invalid-feedback" v-if="enviado && !$v.persona.codigo_postal.required">
                          Debe ingresar un Codigo Postal
                        </div>
                        <div class="invalid-feedback" v-if="persona.codigo_postal && !$v.persona.codigo_postal.numeric">
                          Sólo se aceptan números
                        </div>
                      </template>
                    </float-label>
                  </div>
                </div>
              </div>
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="border-bottom"><i class="fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Otros</h5>
                  <div class="row pt-3">
                    <float-label label="Sexo" clase="col-sm-6 col-12">
                      <select name="sexo" id="sexo" class="form-control" v-model="persona.sexo"
                              :class="enviado && !$v.persona.sexo.required ? 'is-invalid' : '' ">
                        <option value=null selected>Seleccione...</option>
                        <option value="Masculino">Masculino</option>
                        <option value="Femenino">Femenino</option>
                        <option value="Otro">Otro</option>
                      </select>
                      <template v-slot:validation>
                        <div class="invalid-feedback" v-if="enviado && !$v.persona.sexo.required">
                          Debe ingresar un Sexo
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Teléfono" clase="col-sm-6 col-12">
                      <input id="telefono" v-model="persona.telefono" placeholder="Ingresar un telefono..." type="text"
                             inputmode="numeric" class="form-control"/>
                    </float-label>
                    <float-label label="Email" clase="col-sm-6 col-12">
                      <input id="email" v-model="persona.email" placeholder="Ingresar un email..." type="text"
                             inputmode="email" class="form-control"/>
                    </float-label>
                    <float-label label="Antigüedad" clase="col-sm-6 col-12">
                      <input id="antiguedad" v-model="persona.antiguedad" placeholder="Ingresar una antiguedad..."
                             type="text" inputmode="numeric" class="form-control"/>
                    </float-label>
                    <float-label label="Estado Civil" clase="col-sm-6 col-12">
                      <input id="estadoCivil" v-model="persona.estado_civil" placeholder="Ingresar una estado civil..."
                             type="text" class="form-control"
                             :class="enviado && !$v.persona.estado_civil.required ? 'is-invalid' : '' "/>
                      <template v-slot:validation>
                        <div class="invalid-feedback" v-if="enviado && !$v.persona.estado_civil.required">
                          Debe ingresar un Estado civil
                        </div>
                      </template>
                    </float-label>
                  </div>
                </div>
              </div>
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="border-bottom"><i class="fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Datos afip
                  </h5>
                  <div class="row pt-3">
                    <float-label label="Código de actividad" clase="col-sm-4 col-12">
                      <input
                        id="codigo_actividad"
                        v-model="persona.datos_afip[0].codigo_actividad"
                        placeholder="Ingresar un código de actividad..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                      />
                    </float-label>
                    <float-label label="Cantidad de adherentes" clase="col-sm-4 col-12">
                      <input
                        id="cantidad_adherentes"
                        v-model="persona.datos_afip[0].cantidad_adherentes"
                        placeholder="Ingresar cantidad de adherentes..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                      />
                    </float-label>
                    <float-label label="Código de obra social" clase="col-sm-4 col-12">
                      <input
                        id="codigo_obra_social"
                        v-model="persona.datos_afip[0].codigo_obra_social"
                        placeholder="Ingresar un código de obra social..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                      />
                    </float-label>
                    <float-label label="Código modalidad contratacion" clase="col-sm-4 col-12">
                      <input
                        id="codigo_modalidad_contratacion"
                        v-model="persona.datos_afip[0].codigo_modalidad_contratacion"
                        placeholder="Ingresar un código de contratación..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"/>
                    </float-label>
                    <float-label label="Código de zona" clase="col-sm-4 col-12">
                      <input
                        id="codigo_zona"
                        v-model="persona.datos_afip[0].codigo_zona"
                        placeholder="Ingresar un código de zona..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"/>
                    </float-label>
                    <float-label label="CBU" clase="col-sm-4 col-12">
                      <input
                        id="cbu"
                        v-model="persona.cbu"
                        placeholder="Ingresar un cbu"
                        type="text"
                        inputmode="numeric"
                        class="form-control"/>
                    </float-label>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 mb-4">
                <button class="mt-1 btn btn-info float-right col-2 mb-4">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import Persona from "@/models/persona";
import axios from "axios";
import Swal from "sweetalert2";
import {required, numeric} from "vuelidate/lib/validators";

export default {
  name: "NuevaPersona",
  components: {
    TituloComponente,
    FloatLabel,
  },
  validations: {
    persona: {
      nombre: {required},
      apellido: {required},
      numero_afiliado: {required, numeric},
      cuil: {required, numeric},
      provincia: {required},
      localidad: {required},
      domicilio: {required},
      codigo_postal: {required, numeric},
      fecha_nacimiento: {required},
      sexo: {required},
      dni: {required, numeric},
      estado_civil: {required},
      tipo_documento: {required},
      nacionalidad: {required},
    },
  },
  data() {
    return {
      persona: new Persona(
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        'D.N.I.',
        null,
        null,
        null,
        null,
        null,
        null,
        [
          {
            conyuge: 0,
            cantidad_hijos: 0,
            codigo_situacion: 0,
            codigo_condicion: 0,
            codigo_actividad: 0,
            codigo_zona: 0,
            porcentaje_aporte_adic_SS: 0,
            codigo_modalidad_contratacion: 0,
            codigo_siniestrado: 0,
            codigo_obra_social: 0,
            cantidad_adherentes: 0,
            provincia_localidad: "La Pampa, Santa Rosa",
            corresponde_reduccion: 0,
          }
        ]
      ),
      provincias: null,
      provinciaSelected: null,
      municipios: null,
      loading: false,
      enviado: false,
    };
  },
  created() {
    this.obtenerProvincias();
  },
  methods: {
    guardarPersona() {
      this.enviado = true;
      this.$v.$touch();
      this.loading = true;
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/personas", this.persona)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.persona.nombre} ${res.data.persona.apellido} se guardó con éxito.`
            });
            this.$router.push({name: "ListarPersonas"});
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: error.response?.data?.error ?? `No se ha podido completar la operación.`
          });
        });
    },
    obtenerProvincias() {
      axios
        .get("/provincias")
        .then((res) => {
          if (res.data.provincias) {
            this.provincias = res.data.provincias;
            this.provincias.sort(function (a, b) {
              if (a.nombre > b.nombre) {
                return 1;
              }
              if (a.nombre < b.nombre) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    obtenerMunicipios() {
      axios
        .get("/localidades?provincia=" + this.provinciaSelected.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.localidades) {
            this.municipios = res.data.localidades;
            this.municipios.sort(function (a, b) {
              if (a.nombre > b.nombre) {
                return 1;
              }
              if (a.nombre < b.nombre) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
            this.persona.provincia = this.provinciaSelected.nombre;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },
};
</script>
